<script lang="ts">
	import { SidepanelContent } from '@Shelly/shelly-design-system';

	import ControlColor from 'src/components/Controls/Single/ControlColor.svelte';
	import ControlTemp from 'src/components/Controls/Single/ControlTemp.svelte';
	import { real_id } from 'src/helpers/interface_helpers';
	import { devices_status } from 'src/stores/device-runtime/status';

	import type { Device } from 'src/types/Device';

	export let device: Device;

	$: status = $devices_status[real_id(device.id)];
	$: isCct = /^(cct):\d+$/.test(device?.component);
	$: isColor = /^(rgb|rgbw):\d+$/.test(device?.component);
</script>

<SidepanelContent>
	<div class="secondary-controls-wrapper">
		{#if isCct}
			<ControlTemp {device} {status} />
		{:else if isColor}
			<ControlColor {device} {status} />
		{/if}
	</div>
</SidepanelContent>
